export const defaultState = {
  loading: false,
  fetchingUser: true,
  strongPassword: true,
  document: {},
  onWait:false
};
